import { Navigate, Route, Routes } from "react-router-dom"
import AppShell from "@/components/layout/AppShell"
import LoginPage from "@/routes/login"
import HomePage from "@/routes/home"
import PapersPage from "@/routes/papers"
import PaperDetailPage from "@/routes/paper-detail"
import NewslettersPage from "@/routes/newsletters"
import NewsletterDetailPage from "@/routes/newsletter-detail"
import PreferencesPage from "@/routes/preferences"
import KeywordsPage from "@/routes/keywords"
import BookmarksPage from "@/routes/bookmarks"
import { useMe } from "@/hooks/useAuth"

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: me, isLoading } = useMe()
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Loading...
      </div>
    )
  }
  if (!me) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/papers" element={<PapersPage />} />
        <Route path="/papers/:id" element={<PaperDetailPage />} />
        <Route path="/newsletters" element={<NewslettersPage />} />
        <Route path="/newsletters/:id" element={<NewsletterDetailPage />} />
        <Route path="/me" element={<PreferencesPage />} />
        <Route path="/me/keywords" element={<KeywordsPage />} />
        <Route path="/me/bookmarks" element={<BookmarksPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
